import Editor, { Monaco } from '@monaco-editor/react';
import classNames from 'classnames';
import * as React from 'react';
import { AsyncButton, Button, Modal, NotificationBlock, useToast } from 'uxp/components';
import { Conditional } from './ConditionalComponent';
import MarkdownView from './Markdown/MarkdownView';

interface IEditorComponent {
    value: string,
    language: string,
    className?: string,
    styles?: any
    theme?: "vs-dark" | "light",
    onSave: (value: string) => Promise<any>
    onCancel: () => void,
    options?: {
        wordWrap?: "off" | "on" | "wordWrapColumn" | "bounded"
    }
    showNotification?: boolean
}

const EditorComponent: React.FunctionComponent<IEditorComponent> = (props) => {
    // props
    let { value, theme, language, className, styles, onSave, onCancel, options, showNotification } = props

    //state
    let [loading, setLoading] = React.useState<boolean>(true)
    let [preview, setPreview] = React.useState<boolean>(false)
    let [textareaValue, setTextareaValue] = React.useState<string>("")

    //refs
    let editorRef = React.useRef(null);

    let Toast = useToast()

    React.useEffect(() => {
        if (language == "text") {
            setTextareaValue(value)
            setLoading(false)
        }
    }, [language])

    const onEditorMount = (editor:any, monaco: any) => {
        editorRef.current = editor;
        setLoading(false)
    }

    const onSaveChanges = async (): Promise<any> => {
        console.log("saving....")

        let value = ""

        if (language == "text") {
            value = textareaValue
        }
        else {
            value = editorRef.current.getValue()
        }

        try {
            let res = await onSave(value)
            console.log("REsp :", res)
            if (res) {
                if(showNotification) Toast.success("Your changes saved!")
                return new Promise<any>((resolve, reject) => {
                    onCancel()
                    resolve("done")
                })
            }

           if(showNotification) Toast.error("Unable to save changes, something went wrong!")
            console.log("Exception: didn't get a response")
            return new Promise<any>((resolve, reject) => {
                reject("saving failed")
            })
        }
        catch (e) {
            console.log("Exception : ", e)
           if(showNotification) Toast.error("Unable to save changes, something went wrong!")
            return new Promise<any>((resolve, reject) => {
                reject(e)
            })
        }
    }
    const onCancelChanges = () => {
        console.log("canceling....")
        onCancel()
    }

    const onTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        let val = e.target.value
        setTextareaValue(val)
    }

    let _options: any = {
        lineNumbers: false,
        minimap: {
            enabled: false
        },
        wordWrap: "on"
    }

    _options = { ..._options, options }

    return (<div className={classNames("editor-component", className)} style={styles}>
        <div className="editor-cont">
            <Conditional visible={language != "text"} >
                <Editor
                    height="100%"
                    theme={theme}
                    language={language}
                    value={value}
                    onMount={onEditorMount}
                    options={_options}
                    loading={<NotificationBlock message="Loading..." class="editor-loading-message" />}
                />
            </Conditional>
            <Conditional visible={language == "text"}>
                <textarea
                    value={textareaValue}
                    onChange={onTextareaChange}
                    className="editor-text-input"
                    autoFocus
                />
            </Conditional>
        </div>
        <div className="footer">
            <Conditional visible={!loading}>
                <AsyncButton title="Save Changes" onClick={onSaveChanges} loadingTitle={"Saving..."} />

                <Conditional visible={language == "markdown"}>
                    <Button title="preview" onClick={() => setPreview(true)} />
                </Conditional>

                <Button title="Cancel" onClick={onCancelChanges} />
            </Conditional>

            <Conditional visible={loading}>
                <NotificationBlock message="Loading..." class="editor-loading-message" />
            </Conditional>

        </div>

        <Modal
            show={preview}
            onOpen={() => { }}
            onClose={() => { setPreview(false) }}
            className="model-description-preview"
            title="Preview"
        >
            <MarkdownView text={editorRef.current ? editorRef.current.getValue() : ""} />
        </Modal>
    </div>)
}

EditorComponent.defaultProps = {
    theme: "vs-dark",
    styles: {}
}

export default EditorComponent